export default __webpack_public_path__ + "static/media/Version (2) - LOTR - Thumbnail.cbc37658.png";